<div id="loader-overlay"></div>
<div id="loader-container">
  <nz-card>
    <i nz-icon nzType="loading" [nzSpin]="true"></i>
    <div id="loading-text" [innerHTML]="'app.loader.message' | translate"></div>
  </nz-card>
</div>
